// React Dependencies
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

// External Dependencies
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

// Internal Dependencies
import { WindowSize, Url, Status } from '../../../common/constants';
import { IsEmpty } from '../../../common/checks';
import ApiService from '../../../services/apiService';
import layoutAction from '../../../actions/layout';
import LoyaltyProgramSidebarMenu from './LoyaltyProgramSidebarMenu';
// import MembershipSetting from './MembershipSetting/MembershipSetting';
import LoyaltyCard from './LoyaltyCard/LoyaltyCard';
import StampSettings from './StampSettings/StampSettings';
// import TransactionHistory from './TransactionHistory/TransactionHistory';
// import Members from './Members/Members';
import Analytics from './Analytics';
import MapSettings from './MapSettings';

const CONST_MapSettings = 'Map Settings';

const LoyaltyProgramMenuItems = [
  // {
  //   id:   1,
  //   name: 'Info',
  //   url:  Url.LoyaltyCardInfo,
  // },
  // {
  //   id:   2,
  //   name: 'Stamp Settings',
  //   url:  Url.StampSettings,
  // },
  {
    id:   4,
    name: CONST_MapSettings,
    url:  Url.MapSettings,
  },
  {
    id:   5,
    name: 'Analytics',
    url:  Url.LoyaltyCardAnalytics,
  },
  // {
  //   id:   5,
  //   name: 'Transaction History',
  // },
  // {
  //   id:   6,
  //   name: 'Membership Setting',
  // },
];

const LoyaltyProgram = (props) => {
  const { loyaltyCardId, pageId } = props.match.params;
  const history = useHistory();
  const [menuItems, setMenuItems] = useState(LoyaltyProgramMenuItems);

  const [selectedMenuItem, setSelectedMenuItem] = useState(menuItems.find((item) => item.url === props.match.path));
  const [loyaltyCardStatus, setLoyaltyCardStatus] = useState(Status.Draft);

  const selectMenuItemHandler = (menuItem) => {
    if (IsEmpty(menuItem.url)) {
      return;
    }
    setSelectedMenuItem(menuItem);
    history.push(menuItem.url.replace(':pageId', props.match.params.pageId).replace(':loyaltyCardId', props.match.params.loyaltyCardId));
  };

  const closeMenuHandler = () => {
    setSelectedMenuItem({ id: '' });
    props.dispatchLoyaltyProgramSideBarHide();
    history.push(Url.LoyaltyCards.replace(':pageId', props.match.params.pageId));
  };

  const getLoyaltyCard = async () => {
    try {
      const res = await ApiService.getLoyaltyCard(pageId, loyaltyCardId);

      const { status } = res;
      setLoyaltyCardStatus(status);
    } catch (err) {
      console.log(err);
      toast.error(err.message);
    }
  };

  const getPageMapBound = async () => {
    const mapBound = await ApiService.getMapBound(props.match.params.pageId);

    // remove <Map Settings> menu when page doesn't have the Geographic Boundary
    if (IsEmpty(mapBound)) {
      const deleteMenuIndex = menuItems.findIndex((menu) => menu.name === CONST_MapSettings);
      if (deleteMenuIndex !== -1) {
        menuItems.splice(deleteMenuIndex, 1);
        setMenuItems([]);
        setMenuItems(menuItems);
      }
    }
  };

  useEffect(() => {
    getPageMapBound();
  }, []);

  useEffect(() => {
    getLoyaltyCard();
  }, [loyaltyCardId, pageId]);

  useEffect(() => {
    if (props.layout.windowSize === WindowSize.Mobile && props.layout.showSideBar === false) {
      props.dispatchLoyaltyProgramSideBarHide();
    } else {
      props.dispatchLoyaltyProgramSideBarShow();
    }
  }, [props.layout.showSideBar]);

  const getSelectedMenuItemContent = () => {
    switch (props.match.path) {
      // Uncomment "case Url.LoyaltyCard" when u are doing development, but do not push it to
      // PR until we are ready to launch in production
      // case Url.LoyaltyCard:
      case Url.LoyaltyCardInfo:
        return <LoyaltyCard match={props.match} />;

      case Url.StampSettings:
        return <StampSettings match={props.match} />;

      case Url.LoyaltyCardAnalytics: {
        if (loyaltyCardStatus !== Status.Live) {
          return null;
        }
        return <Analytics match={props.match} />;
      }
      case Url.MapSettings:
        return <MapSettings match={props.match} />;
      // case 3:
      //   return <TransactionHistory />;
      // case 4:
      //   return <MembershipSetting />;
      default:
        return <Analytics match={props.match} />;
    }
  };

  return (
    <div className="container-fluid mt-3">
      {props.layout.showLoyaltyProgramSideBar && (
        <LoyaltyProgramSidebarMenu
          match={props.match}
          menuItems={menuItems}
          selectedMenuItem={selectedMenuItem}
          onSelectMenuHandler={selectMenuItemHandler}
          onCloseMenuHandler={closeMenuHandler}
        />
      )}
      {getSelectedMenuItemContent(selectedMenuItem)}
    </div>
  );
};

LoyaltyProgram.propTypes = {
  match:                             PropTypes.shape(Object).isRequired,
  layout:                            PropTypes.shape(Object).isRequired,
  dispatchLoyaltyProgramSideBarHide: PropTypes.func.isRequired,
  dispatchLoyaltyProgramSideBarShow: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  layout: state.layout,
});

const mapDispatchToProps = (dispatch) => ({
  dispatchLoyaltyProgramSideBarShow: () => layoutAction.loyaltyProgramSideBarShow(dispatch),
  dispatchLoyaltyProgramSideBarHide: () => layoutAction.loyaltyProgramSideBarHide(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoyaltyProgram);
